/*
  Wear It With (sections/alt-wear-it-with.liquid).

  Fetches the section back through the product recommendations endpoint with
  intent=complementary, because the `recommendations` object is populated on
  no other render. Three outcomes, and the band paints in only one of them:

    complementary picks exist -> inject them, reveal
    none, but theme.upsell does -> clone the server-rendered fallback, reveal
    neither, or the fetch fails -> stay hidden, leaving no gap on the page

  The theme's stock `complementary-products.js` cannot drive this: it fires no
  event and takes no action on an empty result, so it can neither reveal the
  band nor trigger the fallback. It also waits on an IntersectionObserver,
  which is unusable here because the element starts `display: none`.
*/
(function () {
  'use strict';

  const ITEMS = '[data-wiw-items]';
  const ITEM = '[data-grid-item]';
  const MOBILE_SLIDER_CLASS = 'grid--mobile-slider';

  class AltWearItWith extends HTMLElement {
    connectedCallback() {
      this.target = this.querySelector('[data-wiw-target]');
      this.fallback = this.querySelector('[data-wiw-fallback]');

      const url = this.getAttribute('data-url');

      if (!this.target || !url) {
        this.useFallback();
        return;
      }

      fetch(url)
        .then((response) => response.text())
        .then((html) => {
          const items = new DOMParser().parseFromString(html, 'text/html').querySelector(ITEMS);

          if (items && items.querySelector(ITEM)) {
            this.target.innerHTML = items.innerHTML;
            this.reveal('complementary');
          } else {
            this.useFallback();
          }
        })
        .catch(() => this.useFallback());
    }

    useFallback() {
      if (!this.target || !this.fallback || !this.fallback.content.querySelector(ITEM)) {
        this.setAttribute('data-state', 'empty');
        return;
      }

      this.target.appendChild(this.fallback.content.cloneNode(true));
      this.reveal('upsell');
    }

    reveal(source) {
      // Mirrors related-products.js: the mobile slider is a class the grid only
      // gets once its items are in the DOM, not a state the markup can carry.
      if (this.getAttribute('data-mobile-slider') === 'true') {
        const grid = this.target.querySelector('.grid');
        if (grid) grid.classList.add(MOBILE_SLIDER_CLASS);
      }

      this.setAttribute('data-source', source);
      this.setAttribute('data-state', 'ready');
      this.dispatchEvent(new CustomEvent('theme:wear-it-with:loaded', { bubbles: true, detail: { source: source } }));
    }
  }

  if (!customElements.get('alt-wear-it-with')) {
    customElements.define('alt-wear-it-with', AltWearItWith);
  }
})();
